// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609242310/js/" + chunkId + "." + {"44":"cf642e0a","225":"fc1bada2","481":"08b62988","486":"078b0fb4","770":"fc120763"}[chunkId] + ".0.6317247219127652.chunk.js";
};